<script setup>
const props = defineProps({
  label: {
    type: String,
    default() {
      return '';
    },
  },
  type: {
    type: String,
    default() {
      return 'default';
    },
  },
  required: {
    type: Boolean,
    default() {
      return false;
    },
  },
});
</script>

<template>
  <span
    :class="[
      'ui-label',
      {'ui-label_required': required},
      `ui-label_${type}`
    ]"
  >
    {{ label }}
  </span>
</template>

<style lang="scss">
.ui-label {
  text-transform: uppercase;
  color: #303634;
  display: block;

  &_required {
    position: relative;

    &:after {
      content: "*";
      color: #ed8585;
      right: -2px;
      position: relative;
    }
  }

  &_default {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  &_registration {
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 5px;
  }

  &_filter {
    position: absolute;
    left: 12px;
    text-transform: initial;
    font-size: 13px;
    font-weight: 600;
    word-break: break-word;
  }
}
</style>
